// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tpeIRtlTLhBk3DWiVNSn {
	display: flex;
	gap: 12px;
	list-style: none;
	margin: 0;
	padding: 0;

	/* Directions */
}

.tpeIRtlTLhBk3DWiVNSn.FZwygf45fL4Djn1DCS68 {
		flex-direction: row;
	}

.tpeIRtlTLhBk3DWiVNSn.GijnFshCpuxC7h1THcR3 {
		flex-direction: column;
	}

/* Styles */

.tpeIRtlTLhBk3DWiVNSn.uGz8BnAHKPh8puPniGUY {
		gap: 0;
	}

.tpeIRtlTLhBk3DWiVNSn.uGz8BnAHKPh8puPniGUY .BhJhD8uwLpwBQcKE5Kta {
			padding: 6px 0;
			border-bottom: 1px solid #edf2f8;
		}

.BhJhD8uwLpwBQcKE5Kta {
	position: relative;
}
`, "",{"version":3,"sources":["webpack://./src/components/List/List.pcss"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,SAAS;CACT,gBAAgB;CAChB,SAAS;CACT,UAAU;;CAEV,eAAe;AAkBhB;;AAjBC;EACC,mBAAmB;CACpB;;AAEA;EACC,sBAAsB;CACvB;;AAEA,WAAW;;AACX;EACC,MAAM;CAMP;;AAJC;GACC,cAAc;GACd,gCAAgC;EACjC;;AAIF;CACC,kBAAkB;AACnB","sourcesContent":[".list {\n\tdisplay: flex;\n\tgap: 12px;\n\tlist-style: none;\n\tmargin: 0;\n\tpadding: 0;\n\n\t/* Directions */\n\t&.horizontal {\n\t\tflex-direction: row;\n\t}\n\n\t&.vertical {\n\t\tflex-direction: column;\n\t}\n\n\t/* Styles */\n\t&.divided {\n\t\tgap: 0;\n\n\t\t.item {\n\t\t\tpadding: 6px 0;\n\t\t\tborder-bottom: 1px solid #edf2f8;\n\t\t}\n\t}\n}\n\n.item {\n\tposition: relative;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"list": `tpeIRtlTLhBk3DWiVNSn`,
	"horizontal": `FZwygf45fL4Djn1DCS68`,
	"vertical": `GijnFshCpuxC7h1THcR3`,
	"divided": `uGz8BnAHKPh8puPniGUY`,
	"item": `BhJhD8uwLpwBQcKE5Kta`
};
export default ___CSS_LOADER_EXPORT___;
